import { render, staticRenderFns } from "./ZohoDealsSection.vue?vue&type=template&id=5a36c252&scoped=true"
import script from "./ZohoDealsSection.vue?vue&type=script&lang=js"
export * from "./ZohoDealsSection.vue?vue&type=script&lang=js"
import style0 from "./ZohoDealsSection.vue?vue&type=style&index=0&id=5a36c252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36c252",
  null
  
)

export default component.exports